import React, { useState, useEffect } from 'react';
import { Container, Table, Spinner, Alert, Button } from 'react-bootstrap';
import { getData } from '../services/api';
import { useNavigate } from 'react-router-dom';

const AdminPage = () => {
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getData();
        // Exclude appointment requests — they have their own admin view
        setRegistrations(data.filter((item) => item.type !== 'appointment'));
      } catch (err) {
        console.error('Error fetching registrations:', err);
        setError('Failed to load registrations. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem('isAuthenticated');
    navigate('/login');
  };

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-5">
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Registrations</h1>
        <div>
          <Button variant="outline-primary" className="me-2" onClick={() => navigate('/admin/appointments')}>
            <i className="bi bi-calendar-check"></i> Appointments
          </Button>
          <Button variant="primary" className="me-2" onClick={() => navigate('/admin/check-in')}>
            <i className="bi bi-check2-square"></i> Check-In
          </Button>
          <Button variant="outline-danger" onClick={handleLogout}>Logout</Button>
        </div>
      </div>
      
      {registrations.length === 0 ? (
        <Alert variant="info">No registrations found.</Alert>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Spouse</th>
              <th>Invited By</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {registrations.map((reg) => (
              <tr key={reg.id}>
                <td>{reg.firstName} {reg.lastName}</td>
                <td>{reg.email}</td>
                <td>{reg.phone}</td>
                <td>{reg.spouseFirstName && reg.spouseLastName ? `${reg.spouseFirstName} ${reg.spouseLastName}` : '-'}</td>
                <td>{reg.invitedBy}</td>
                <td>{new Date(reg.timestamp).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Container>
  );
};

export default AdminPage;